import script from "./ConsultationChat.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultationChat.vue?vue&type=script&setup=true&lang=js"

import "./ConsultationChat.vue?vue&type=style&index=0&id=2d7c7c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7c7c3e"]])

export default __exports__